import './_hatbox-ugc.scss';
import component from './hatbox-ugc';

export default component;
